import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip, Row, Col, Button } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/pensiunService";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import DataTableBloc from "../Blocs/DataTableBloc";
import apiResponse from "../../../../../services/apiResponse";
import Select from "react-select";

import ReactTimeAgo from "react-time-ago";

var reformatOptionYear = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] = region.id;
    newObj["value"] = region.text;
    return newObj;
  });
};

class TableMonitoringComponent extends Component {
  dataTableBloc = new DataTableBloc();

  source;
  historyTable = "pensiunMonitoringTableInActive";
  defaultOrder = "employee_date_of_pension_new";
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  modal_confirm_status = 0;
  modal_confirm_message = "";
  modal_confirm_sucess_message = "data berhasil di nonaktifkan";
  modal_confirm_error_message = "data gagal di nonaktifkan";

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      submitUuid: null,
      updateUuid: null,
      inactiveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      yearOption: [],
      yearSelected: "",
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );
    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
    };
    await this.dataTableBloc.fetchMonitoring(query, this.source.token);
  };

  downloadData = async () => {
    let year_filter = this.state.yearSelected;
    let query = {
      tahun: year_filter,
    };
    this.dataTableBloc.fetchExport(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        let data_status = parseInt(this.modal_confirm_status);
        if (data_status === 1) {
          this.inactiveData();
        } else {
          this.activeData();
        }
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchMonitoring({ uuid: this.state.inactiveUuid });
  };

  activeData = async () => {
    await this.dataTableBloc.fetchMonitoring({ uuid: this.state.inactiveUuid });
  };

  onChangeTahunSelected = (element) => {
    this.setState({
      yearSelected: element.value,
    });
    let year_filter = element.value;
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );
    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      tahun: year_filter,
    };
    //  console.log(query)
    this.dataTableBloc.fetchMonitoring(query, this.source.token);
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.monitoringChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.loadTahunChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              yearOption: response.result,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.exportChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.response.file_url) {
            window.location.href = result.data.response.file_url;
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.fetchTahun();
    var currentTime = new Date();
    var year_now = currentTime.getFullYear();
    this.setState({
      yearSelected: year_now,
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.monitoringChannel.unsubscribe();
  }

  columns = [
    {
      key: "employee_nip",
      text: "Pegawai",
      sortable: true,
      cell: (record) => {
        let expired = record.is_expired;
        let current_position_uuid = record.employee_last_position_uuid;
        if (
          parseInt(expired) === 1 &&
          current_position_uuid !== "b3a9c878-cdd6-447d-930a-0efd47e61a6f"
        ) {
          return (
            <div className="alert bg-dark text-white">
              <strong>{record.employee_nip}</strong>
              <br></br>
              <strong>{record.employee_full_name}</strong>
            </div>
          );
        } else if (
          parseInt(record.status_month6) === 1 &&
          current_position_uuid !== "b3a9c878-cdd6-447d-930a-0efd47e61a6f"
        ) {
          return (
            <div className="alert alert-danger">
              <strong>{record.employee_nip}</strong>
              <br></br>
              <strong>{record.employee_full_name}</strong>
            </div>
          );
        } else if (
          parseInt(record.status_month12) === 1 &&
          current_position_uuid !== "b3a9c878-cdd6-447d-930a-0efd47e61a6f"
        ) {
          return (
            <div className="alert alert-warning">
              <strong>{record.employee_nip}</strong>
              <br></br>
              <strong>{record.employee_full_name}</strong>
            </div>
          );
        } else if (
          parseInt(record.status_month18) === 1 &&
          current_position_uuid !== "b3a9c878-cdd6-447d-930a-0efd47e61a6f"
        ) {
          return (
            <div className="alert alert-success">
              <strong>{record.employee_nip}</strong>
              <br></br>
              <strong>{record.employee_full_name}</strong>
            </div>
          );
        }
        // else {
        //   return (
        //     <div
        //       dangerouslySetInnerHTML={{
        //         __html:
        //           "<b>" +
        //           record.employee_nip +
        //           "</b><br>" +
        //           record.employee_full_name +
        //           "<br>",
        //       }}
        //     />
        //   );
        // }
        else if (
          // parseInt(expired) !== 1 &&
          // parseInt(record.status_month6) !== 1 &&
          // parseInt(record.status_month12) !== 1 &&
          // parseInt(record.status_month18) !== 1 &&
          current_position_uuid === "b3a9c878-cdd6-447d-930a-0efd47e61a6f"
        ) {
          return (
            <div className="alert  bg-primary text-white">
              <strong>{record.employee_nip}</strong>
              <br></br>
              <strong>{record.employee_full_name}</strong>
            </div>
          );
        } else {
          return (
            <div
              dangerouslySetInnerHTML={{
                __html:
                  "<b>" +
                  record.employee_nip +
                  "</b><br>" +
                  record.employee_full_name +
                  "<br>",
              }}
            />
          );
        }
      },
    },
    {
      key: "employee_current_position_name",
      text: "Posisi",
      sortable: true,
      cell: (record) => {
        let current_position_uuid = record.employee_last_position_uuid;
        let employee_current_position_name =
          record.employee_current_position_name + "  ";
        if (current_position_uuid === "b3a9c878-cdd6-447d-930a-0efd47e61a6f") {
          return (
            <>
              {employee_current_position_name}
              <label className="badge rounded-pill bg-soft-info font-size-12">
                {" "}
                Pensiun
              </label>
            </>
          );
        } else {
          return employee_current_position_name;
        }
      },
    },
    {
      key: "employee_current_work_unit_name",
      text: "Unit Kerja",
      sortable: true,
    },
    {
      key: "employee_current_tmt_position",
      text: "TMT Jabatan",
      sortable: true,
    },
    {
      key: "rank_level_name",
      text: "Golongan",
      sortable: true,
    },
    {
      key: "employee_date_of_pension_new",
      text: "Tgl Pemberhentian",
      sortable: true,
      cell: (record) => {
        let tgl = record.employee_date_of_pension_new;
        if (!tgl) return "-"; // Jika data kosong, tampilkan "-"

        let dateObj = new Date(tgl);
        return dateObj.toLocaleDateString("id-ID", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        });
      },
    },
    {
      key: "employee_date_of_pension_new", // "employee_tmt_pension",
      text: "TMT Pemberhentian",
      sortable: true,
      cell: (record) => {
        let tgl = record.employee_date_of_pension_new;
        var dateParts = tgl.split("-");
        dateParts[2] = "01";
        tgl = dateParts.join("-");
        return tgl;
      },
    },
    {
      key: "employee_age",
      text: "Usia Sekarang",
      sortable: true,
    },
    {
      key: "position_bup", //employee_age_retired
      text: "Usia Pemberhentian",
      sortable: true,
    },
    {
      key: "pension_year_new",
      text: "Tahun Pemberhentian",
      sortable: true,
    },
  ];
  //

  render() {
    return (
      <>
        <br />
        <Row>
          <Col md="2">
            <label>Filter Tahun Pemberhentian : </label>
            <br />
            <Select
              value={this.state.yearOption.filter(
                (option) => option.value === this.state.yearSelected
              )}
              options={this.state.yearOption}
              classNamePrefix="select2-tahun-pensiun"
              placeholder="Pilih Tahun Pemberhentian"
              onChange={this.onChangeTahunSelected}
            />
          </Col>
          <Col md="8">
            <label>Keterangan : </label>
            <br />
            <ul className="list-inline">
              <li className="list-inline-item">
                <div class="alert bg-primary text-white"> Sudah Pensiun</div>
              </li>
              <li className="list-inline-item">
                <div class="alert bg-dark text-white"> Melewati BUP</div>
              </li>
              <li className="list-inline-item">
                <div class="alert alert-danger">0 - 6 Bulan</div>
              </li>
              <li className="list-inline-item">
                <div class="alert alert-warning"> 7 - 12 Bulan </div>
              </li>
              <li className="list-inline-item">
                <div class="alert alert-success"> 13 - 18 Bulan</div>
              </li>
            </ul>
          </Col>
          <Col md="2">
            <label></label>
            <br />
            <Button color="success float-end" onClick={this.downloadData}>
              <i className="uil-download-alt"></i> Unduh Data
            </Button>
          </Col>
        </Row>
        <br />
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
      </>
    );
  }
}

export default TableMonitoringComponent;
